import Bind from 'bind.js';

let titleFieldMapping = {
    'blog': 'title',
    'faqs': 'question',
    'resources': 'title'
};

let urlMapping = {
    'blog': 'blog.html',
    'faqs': 'faqs.html',
    'resources': 'resources.html',
};

let cssClassMapping = {
    'blog': 'glyphicon-book',
    'faqs': 'glyphicon-question-sign',
    'resources': 'glyphicon-bookmark',
};

let iconTitleMapping = {
    'blog': 'Blog',
    'faqs': 'FAQ',
    'resources' : 'Resource'
};

export default class SearchResult {

    constructor(options) {
        this.parentElement = options.parentElement;
        this.data = options.data;
        this.addContent();
    }

    addContent() {
        let template = `
          <div class="span12">
            <div class="copy search-results">
                <div class="intro_copy">
                    <h1>Search results</h1>      
                </div>    
            </div>
            <div class="span12 search-results-container">
                <ul class="search-result-items">                    
                </ul>
            </div>
          </div>
        `;

        this.parentElement.insertAdjacentHTML("afterbegin", template);

        this.editor = Bind(
            {
                items: this.data
            },
            {
                items: {
                    dom: '.search-result-items',
                    transform: function(item) {
                        let url = urlMapping[item._searchType];
                        let description = '';
                        let cssClass = cssClassMapping[item._searchType] ? cssClassMapping[item._searchType] : "";
                        let title = iconTitleMapping[item._searchType] ? iconTitleMapping[item._searchType] : "";
                        if (item._searchType == 'faqs') {
                            url += '?faq='+item._index;
                            description = SearchResult.getShortDescription(item.answer, 220);
                        } else if (item._searchType == 'blog' || item._searchType == 'resources') {
                            url += '?idx='+item._index;
                            description = SearchResult.getShortDescription(item.content, 220);
                        }
                        return `<li class="search-result-item">
                            <div class="search-link">
                                <div>
                                    <span title="${title}" class="glyphicon ${cssClass}"></span>
                                    <a href="${url}" target="_blank">${item[titleFieldMapping[item._searchType]]}</a>
                                </div>                                
                                <p>${description}</p>
                            </div>
                        </li>`;
                    }
                },
            }
        );

        this.isEmptySearchResult();
    }

    static getShortDescription(str, length, searchString) {
        // strip html from string
        var tmp = document.createElement("div");
        tmp.innerHTML = str;
        var s_ = tmp.textContent || tmp.innerText || "";

        var isTooLong = str.length > length;
        if (isTooLong) {
            s_ = s_.substr(0, length - 1);
            s_ = s_.substr(0,s_.lastIndexOf(' '));
        }

        return  isTooLong ? s_ + '&hellip;' : s_;
    }

    reRender(data) {
        this.data = data;
        this.editor.items = data;
        this.isEmptySearchResult();
    }

    isEmptySearchResult() {
        if (this.data.length === 0) {
            let emptyResultElement = document.getElementById('search-empty-result');
            if (!emptyResultElement) {
                let emptyResultTemplate = `
                <div id="search-empty-result">
                    <p>No items found</p>
                </div>
            `;
                document.getElementsByClassName('search-results-container')[0].insertAdjacentHTML("afterbegin", emptyResultTemplate);
            }
        } else {
            let emptyResultElement = document.getElementById('search-empty-result');
            if (emptyResultElement) {
                emptyResultElement.parentNode.removeChild(emptyResultElement);
            }
        }
    }

}



// WEBPACK FOOTER //
// ./src/renderers/SearchResult.js